import { render, staticRenderFns } from "./SelectedComponent.vue?vue&type=template&id=e7ca6744"
import script from "./SelectedComponent.vue?vue&type=script&lang=js"
export * from "./SelectedComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports